module.exports = __webpack_public_path__ + "media/img/help_center/Institution_Scholarship_Creation_27-5b8068b185922064ca31752d793261b8.gif";